import { OKTA_USER_INFO, SET_MARKET_LANGUAGES, SET_MARKET_LANGUAGES_LOADER, SET_COUNTRIES, SET_COUNTRIES_LOADER, SET_COUNTRIES_ERROR } from "../actions/commonDataActions";

  const initialState = {
    oktaUserInfo: null,
    marketLanguages: [],
    marketLanguagesLoader: false,
    countries: [],
    countriesLoading: false,
    countriesError: null,
  };
  
  export const commonDataReducer = (state = initialState, action) => {
    switch (action.type) {
      case OKTA_USER_INFO:
        return {
          ...state,
          oktaUserInfo: action?.payload || [],
        };

      case SET_MARKET_LANGUAGES:
        return {
          ...state,
          marketLanguages: action?.payload || [],
        };
  
        case SET_MARKET_LANGUAGES_LOADER:
          return {
            ...state,
            marketLanguagesLoader: action?.payload || state.marketLanguagesLoader,
          };

      case SET_COUNTRIES:
        return {
          ...state,
          countries: action?.payload || [],
        };

      case SET_COUNTRIES_LOADER:
        return {
          ...state,
          countriesLoading: action?.payload || false,
        };

      case SET_COUNTRIES_ERROR:
        return {
          ...state,
          countriesError: action?.payload || null,
        };


      default:
        return state;
    }
  };
  